import * as React from 'react';

// ICONS
import { ReactComponent as DefaultIcon } from '../assets/svg/early-learning.svg';

interface OrganisationLogoTypes {
	src?: string;
	extraClass?: string;
	alt?: string;
	size?: number;
	isProfileInComplete?: boolean;
}

const OrganisationLogo: React.FC<OrganisationLogoTypes> = ({ src, extraClass, alt, size, isProfileInComplete }) => {
	const [mounted, setIsMounted] = React.useState<boolean>(false);

	const [isLoading, setIsLoading] = React.useState<boolean>(true);
	
	const [imageError, setImageError] = React.useState<boolean>(false);

	React.useEffect(() => {
		setIsMounted(true);
	}, []);

	const [imageSrc, setImageSrc] = React.useState<string>(src || '');

	React.useEffect(() => {
		if (mounted) {
			setImageSrc(src || '');
		}

		if (src !== undefined) {
			setIsLoading(false);
		}
	}, [src]);

	return (
		<div className="logo-wrapper">
			<div className={`standard-logo-container ${extraClass ? extraClass : ''} `} style={{ height: size, width: size }}>
				{isLoading ? null : src && !imageError ? (
					<img
						className="standard-logo"
						src={imageSrc}
						alt={alt}
						onError={() => {
							setImageError(true);
						}}
					/>
				) : (
					(imageError || !src) && (
						<div className="org-avatar">
							<DefaultIcon />
						</div>
					)
				)}
			</div>
		</div>
	);
};

export default OrganisationLogo;
